export default __webpack_public_path__ + "static/media/motherTwelve.1bc92a66.jpeg";